import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDownload6 = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 406,
	height: 806,
	viewBox: "0 0 406 806",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		opacity: .6,
		clipPath: "url(#clip0_353_7749)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M506.074 389.555C506.124 389.555 506.173 389.556 506.223 389.556C505.044 402.655 506.785 411.794 519.643 399.498C529.149 390.325 528.248 389.474 520.375 381.924C507.38 365.745 505.065 373.264 506.074 389.555ZM318.187 284.215C321.297 297.211 340.322 273.79 346.288 270.13C344.406 265.002 339.096 264.696 335.178 262.76C317.688 250.614 321.614 273.946 318.187 284.215ZM475.434 477.57C478.491 452.332 452.583 479.677 444.502 485.144C441.697 493.487 460.703 492.936 466.288 496.439C475.552 498.99 473.475 481.075 475.434 477.57ZM296.02 365.715C301.892 327.589 278.154 359.964 265.903 371.235C254.559 381.69 288.232 398.39 295.416 405.519C305.283 406.064 294.958 373.456 296.02 365.715ZM326.938 467.809C330.544 476.043 335.111 516.384 348.213 509.949C355.794 504.471 384.349 500.527 381.849 490.513C374.542 487.08 323.401 447.987 326.938 467.809ZM395.886 268.202C416.591 283.255 440.445 294.017 462.35 307.585C464.171 309.427 467.151 308.041 467.709 306.263C464.588 294.062 458.368 236.977 442.61 242.508C426.973 251.264 409.089 255.653 395.886 268.202ZM523.439 507.809C558.268 511.33 589.949 495.639 575.057 457.99C579.672 448.418 546.266 398.942 538.151 409.757C520.235 425.815 501.05 439.652 503.433 466.202C501.843 493.84 485.111 508.384 523.439 507.809ZM381.497 167.859C347.906 168.243 337.113 209.711 328.966 236.416C327.476 249.849 351.469 247.798 359.991 254.37C384.956 257.497 409.135 228.721 433.758 221.885C444.72 213.561 416.939 183.92 409.149 176.685C401.862 170.802 394.206 167.281 381.497 167.859ZM405.587 591.929C441.68 592.593 454.418 557.09 464.452 529.481C465.778 525.774 464.242 523.647 460.138 522.113C401.612 496.648 409.835 507.218 353.9 530.937C347.419 548.64 386.643 590.537 405.587 591.929ZM194.524 274.24C192.179 293.335 230.297 360.43 249.137 359.681C285.941 320.384 298.978 320.999 302.084 263.618C304.13 253.291 301.365 252.101 293.311 249.892C261.878 244.595 202.163 231.072 194.524 274.24ZM266.694 527.819C274.493 523.643 331.078 526.509 324.234 509.788C314.029 485.525 316.592 453.373 295.533 435.428C282.852 430.238 253.343 392.211 244.031 398.502C202.671 445.841 175.299 526.788 266.694 527.819ZM604.143 263.777C602.756 196.297 519.021 213.208 477.281 230.054C472.339 245.414 490.841 276.628 493.05 294.974C499.458 339.576 506.192 341.572 539.656 369.55C543.059 372.283 544.83 372.141 547.973 368.759C573.928 339.803 601.159 303.033 604.143 263.777ZM315.812 377.276C308.19 438.155 349.693 442.053 393.471 467.264C422.839 489.856 447.636 451.492 473.078 438.653C485.416 423.143 476.528 397.977 478.949 379.003C475.898 364.365 479.82 344.569 465.44 335.489C438.502 317.602 412.424 298.885 383.245 284.827C361.803 276.02 341.095 309.522 322.45 318.38C306.529 332.824 316.3 358.348 315.812 377.276ZM254.867 229.265C269.942 229.996 284.789 231.896 299.483 235.227C306.252 236.761 307.432 236.201 309.658 229.216C321.927 192.598 351.382 124.383 399.404 145.852C425.773 156.477 444.96 179.118 459.406 202.989C462.899 208.873 464.103 209.127 470.946 206.943C516.864 194.041 596.387 176.083 616.188 234.619C632.438 290.347 592.75 343.203 560.613 385.629C556.171 391.495 564.377 396.315 566.69 401.258C577.198 415.02 581.969 432.562 594.055 444.78C614.022 484.447 596.871 533.086 546.709 534.3C530.415 539.59 496.875 525.389 488.122 534.4C476.982 565.064 458.327 600.518 424.138 608.99C386.08 616.008 359.83 582.028 343.287 552.739C339.337 538.889 331.983 536.593 319.003 541.437C285.46 548.506 247.254 554.115 216.516 534.904C165.95 498.362 201.1 428.095 228.584 387.56C237.79 374.07 213.815 361.852 208.405 349.867C163.916 294.176 169.831 224.626 254.867 229.265Z",
				fill: "white",
				fillOpacity: .8
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M237.643 601.487C271.843 611.499 223.98 660.438 204.161 662.643C178.413 661.141 228.457 605.858 237.643 601.487Z",
				fill: "white",
				fillOpacity: .8
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M402.61 745.132C392.982 802.46 352.394 711.295 383.631 696.741C404.318 692.277 399.52 730.944 402.61 745.132Z",
				fill: "white",
				fillOpacity: .8
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M133.356 238.766C122.595 234.201 63.7629 239.136 73.4494 217.609C84.3788 193.306 183.124 237.236 133.356 238.766Z",
				fill: "white",
				fillOpacity: .8
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M252.766 172.551C253.267 181.635 246.382 181.682 240.498 179.77C225.973 179.849 194.682 132.167 217.765 131.215C221.568 132.996 224.931 135.435 229.572 133.597C244.565 138.668 250.577 159.172 252.766 172.551Z",
				fill: "white",
				fillOpacity: .8
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M56.9244 386.211C46.5465 388.298 41.407 370.992 51.3176 367.366C65.0601 364.461 97.4669 355.768 107.193 365.737C99.4705 381.173 74.2266 383.74 56.9244 386.211Z",
				fill: "white",
				fillOpacity: .8
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M29.532 314.397C8.36208 317.168 -15.8839 299.196 16.0798 290.227C38.0087 283.695 75.2777 317.092 29.532 314.397Z",
				fill: "white",
				fillOpacity: .8
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M247.795 791.181C245.041 778.585 263.33 742.668 276.51 754.698C280.33 774.536 263.231 789.184 254.573 805.3C247.63 809.451 249.473 795.075 247.795 791.181Z",
				fill: "white",
				fillOpacity: .8
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M357.398 39.8713C355.6 24.7645 369.697 -4.5563 383.179 11.4209C387.246 26.069 361.885 77.0658 357.398 39.8713Z",
				fill: "white",
				fillOpacity: .8
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M130.441 580.013C129.819 568.679 152.304 550.44 158.18 567.026C160.236 574.557 165.925 582.567 157.883 587.453C147.628 596.924 129.493 597.802 130.441 580.013Z",
				fill: "white",
				fillOpacity: .8
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M239.639 23.3469C249.074 68.773 243.197 67.8035 220.7 28.6266C208.1 6.27664 237.792 -2.99942 239.639 23.3469Z",
				fill: "white",
				fillOpacity: .8
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M325.493 615.61C323.252 621.361 323.557 639.275 314.981 638.357C301.978 635.879 301.66 613.156 310.731 605.995C317.876 602.612 326.609 605.535 325.493 615.61Z",
				fill: "white",
				fillOpacity: .8
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M137.209 473.902C125.28 468.563 134.491 456.622 141.696 451.38C147.175 445.549 168.466 449.177 161.85 459.453C154.441 465.513 145.759 468.815 137.209 473.902Z",
				fill: "white",
				fillOpacity: .8
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M427.281 125.715C428.537 149.801 405.666 122.919 412.241 111.538C418.307 96.2832 430.932 115.787 427.281 125.715Z",
				fill: "white",
				fillOpacity: .8
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M55.4955 533.867C51.7882 533.434 48.2267 534.886 46 533.037C48.483 531.662 52.1624 531.094 55.4955 533.867Z",
				fill: "white",
				fillOpacity: .8
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M415.27 368.136C415.388 388.193 400.555 399.138 384.532 403.002C363.75 406.305 354.179 376.526 358.106 359.339C369.055 318.879 412.832 332.894 415.27 368.136Z",
				fill: "white",
				fillOpacity: .8
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_353_7749",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 801,
			height: 806,
			fill: "white"
		})
	}) })]
});
export default SvgDownload6;
